import { Box, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import { setDialogueOpened } from "../../redux/slices/privateChat";
import moment from "moment";
import CircleIcon from "@mui/icons-material/Circle";

interface Props {
  interlocutorId: string;
  lastMessageContent: string;
  createdTimestamp: number | undefined;
  isRead: boolean;
  interlocutorName: string | null | undefined;
}
export const ChatListItem: FC<Props> = ({
  interlocutorId,
  lastMessageContent,
  createdTimestamp,
  isRead,
  interlocutorName
}) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const currentUser = useTypedSelector((state) => state.auth.currentUser);

  const openedDialogue = useTypedSelector(
    (state) => state.privateChat.openedDialogue
  );

  const handleDialogueClick = (
    interlocutorId: string | null | undefined
  ): void => {
    if (interlocutorId) {
      dispatch(
        setDialogueOpened({
          userId: currentUser?.auth0Id ?? "",
          interlocutorId,
          messages:
            openedDialogue?.dialogue?.interlocutorAuth0Id === interlocutorId
              ? openedDialogue?.messages
              : null
        })
      );
      navigate(`${interlocutorId}`);
    }
  };

  const timeAgo = moment(createdTimestamp).fromNow();

  return (
    <div
      style={{
        padding: 12,
        cursor: "pointer",
        borderBottom: "1px solid #9e9e9e"
      }}
    >
      <div
        onClick={() => {
          handleDialogueClick(interlocutorId);
        }}
        color="neutral"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "initial",
          gap: "10px"
        }}
      >
        <Stack direction="row">
          <Box sx={{ flex: 1 }}>
            <span
              style={{
                color: "white",
                fontSize: 20,
                fontWeight: "600"
              }}
            >
              {interlocutorName ?? "No name"}
            </span>
          </Box>

          <Box sx={{ lineHeight: 1.5, textAlign: "right" }}>
            <span
              style={{
                color: "#c3c8ca"
              }}
            >
              {timeAgo}
            </span>

            {!isRead && (
              <CircleIcon
                sx={{ fontSize: 12, marginLeft: "10px" }}
                color="inherit"
              />
            )}
          </Box>
        </Stack>

        <Typography
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: 300,
            color: "#c3c8ca"
          }}
        >
          {lastMessageContent}
        </Typography>
      </div>
    </div>
  );
};
